import React from "react";
import { useTranslation } from 'react-i18next';

/**
 * Info about local currency, airport, climate, business hours
 * @param {*} props 
 * @returns 
 */
function PracticalInfoSection(props) {
    var { t, i18n } = useTranslation();

    return (
        <article>
            <div className="uk-card uk-card-default uk-card-hover uk-border-rounded uk-box-shadow-small">
                <div className="uk-card-body">
                    <h3 className="uk-card-title">{props.sectionTitle}</h3>
                    <ul className="uk-list uk-list-bullet">
                        <li>{props.currencyInfo}</li>
                        <li>{props.airportInfo}</li>
                        <li>{props.climateInfo}</li>
                        <li>{props.businessHoursInfo}</li>
                    </ul>
                </div>
            </div>
        </article>
    );
}

export default PracticalInfoSection;